export default __webpack_public_path__ + "static/media/areax_back.5e3291cd.png";